import React from 'react';
import { PauseCircle, PenLine } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { Btn, fmt } from '../stammakte/ui';

export const AnbindungPause = ({ testId }) => (
  <p className="flex items-start gap-2 border-l-2 border-[#B8893D] pl-3 py-1 text-[13px] text-[#56616D]" data-testid={testId}>
    <PauseCircle className="w-4 h-4 shrink-0 mt-0.5" aria-hidden="true" />
    <span><b>R+V und Creditreform: direkte Anbindung pausiert.</b> Keine Übertragung und kein Abruf. Statuspflege und Datei-Exporte bleiben manuell; externe Fristen gelten weiterhin.</span>
  </p>
);

export const ForderungsBestandsstatus = ({ r }) => (
  <dl className="w-full space-y-1 text-xs text-[#34536b]" data-testid={`rs-bestandsstatus-${r.id}`}>
    {[['inkasso', 'Creditreform', r.inkasso_aktionen], ['ruv', 'R+V', r.ruv_aktionen]].map(([key, label, aktionen]) => (
      <div key={key} className="flex flex-wrap gap-x-2 break-words [overflow-wrap:anywhere]" data-testid={`rs-status-${key}-${r.id}`}>
        <dt className="font-semibold">{label} · intern gespeichert:</dt>
        <dd>{r[key]?.status ? `${aktionen[r[key].status] || r[key].status} · ${r[key].am ? fmt(r[key].am) : 'Datum nicht erfasst'}` : 'Kein Status erfasst'}</dd>
      </div>
    ))}
  </dl>
);

export const ManuelleForderungsStatus = ({ r, run }) => {
  const erfassen = (dienst, aktion, label) => {
    if (!window.confirm(`${label} für Rechnung ${r.nummer} nur intern dokumentieren?\n\nEs werden keine Daten übertragen. Eine notwendige Meldung oder Beauftragung muss außerhalb dieser Anwendung erfolgen.`)) return;
    run(() => api.post(`/kanzlei/rechnungen/${r.id}/${dienst}`, { aktion, manuell: true }), 'Manueller Status gespeichert – keine Daten übertragen');
  };
  return (
    <div className="w-full space-y-2" data-testid={`rs-manuelle-status-${r.id}`}>
      <AnbindungPause testId={`rs-anbindung-pausiert-${r.id}`} />
      <ForderungsBestandsstatus r={r} />
      <div className="flex flex-wrap gap-1.5">
        {Object.entries(r.inkasso_aktionen).map(([k, l]) => <Btn key={k} variant="line" onClick={() => erfassen('inkasso', k, l)} testId={`rs-ink-${k}-${r.id}`} tipp="Nur interner Vermerk, kein Versand an Creditreform"><PenLine className="w-3 h-3" />{l} · vermerken</Btn>)}
        {Object.entries(r.ruv_aktionen).map(([k, l]) => <Btn key={k} variant="ghost" disabled={!r.entbindung_ruv} onClick={() => erfassen('ruv', k, l)} testId={`rs-ruv-${k}-${r.id}`} tipp={r.entbindung_ruv ? 'Nur interner Vermerk, kein Versand an R+V' : 'Erst nach Entbindung möglich'}><PenLine className="w-3 h-3" />{l} · vermerken</Btn>)}
      </div>
    </div>
  );
};